import { useEffect, useState } from 'react'

import { Customer } from 'types/Customer'

import Api from 'services/api'

const useCustomersWithCriticalAndMajorAlerts = (dealerId) => {
  const [customersWithAlerts, setCustomersWithAlerts] = useState<Array<Customer> | null>(null)
  const [isCustomersWithAlertsLoaded, setIsCustomersWithAlertsLoaded] = useState(false)

  useEffect(() => {
    Api.Customers.criticalAndMajorAlerts(dealerId)
      .then((res) => {
        setCustomersWithAlerts(res)
      })
      .catch(() => {
        setCustomersWithAlerts(null)
      })
      .finally(() => {
        setIsCustomersWithAlertsLoaded(true)
      })
  }, [dealerId])

  return { customersWithAlerts, isCustomersWithAlertsLoaded }
}

export default useCustomersWithCriticalAndMajorAlerts
